<template>
  <div class="Main">
    <div v-if="loaded">
      <table class="product-paramerets">
        <tbody>
              <tr v-for="row in product_data" :key="row.id">
                <td>{{row.title}}</td><td>{{row.desc}}</td>
              </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <Loader/>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Loader from "../Loader.vue";

export default {
  components: {
    Loader
  },
  name: "Main",
  data() {
    return {
      loaded: false,
      response: [],
      attrFilters:[],
    };
  },
  props: {
    product_code: {
      type: String,
      required: false
    },
    product_id: {
      type: Number,
      required: false
    }
  },
  created() {
    this.loaded = false;
    if (this.product_id) {
      let api =
        //"https://app.pulsar.pl/wyszukiwarka-www-server/products.php?key=" +
        process.env.VUE_APP_ROOT_QUERY_PARAM+
        "show_only_params.php?key="+this.product_id+
        "&lang="+this.locale;
      Vue.axios.get(api).then(response => {
        this.response = response.data
        this.loaded = true;
        this.$emit("loaded");
      });

      this.getAttributesDB();
    }

  },
  methods: {
    fields(attr) {
      attr.fields;
      // console.log('Main component: field(): attr:',attr);
    },
    getAttributesDB(){
      this.$http.get(process.env.VUE_APP_ROOT_API_DB+"attributes")
      .then(data => {
        this.attrFilters = data.data;
      });
    }


  },
  computed: {
    product_data: function() {
      return this.response.data;
    },
    locale() {
      return this.$store.getters["pricelist/locale"];
    },
    filter_attributes_visible: function() {
      return this.attrFilters.filter(function(i) {
        return i.widoczny === 1
      })
    },
  }
};
</script>
<style lang="less">

div.products table tbody tr td div.Main div table.product-paramerets tbody tr td{
  font-size:12px
}
table.product-paramerets {
  width: 100%;
  text-align: left;
  font-size: 0.8em;
  border-collapse: collapse;
  margin: 0 0 7.5px 0;
  border: 1px solid #e8e8e8;
  tbody {
    border: 0 none;
    tr {
      &:nth-child(odd) {
        background: #fff;
      }
      &:nth-child(even) {
        background: #fff;
      }
      div {
        display: contents;
        td {
          display: block;
          text-align: center;
          font-size: 0.8em;
          border-top: 0 none;
          &:first-child {
            border: 0 none;
            background: #e8e8e8;
            font-weight: 700;
          }
          ul {
            text-align: left;
            padding-left: 15px;
          }
          p {
            margin: 0;
            padding: 0;
          }
          @media (min-width: 576px) {
            display: table-cell;
            text-align: left;
            padding: 3.75px 7.5px;
          }
        }
      }
    }
  }
}

.animation {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Params/Main.vue